import React from 'react';
// Data
import { smallSocialMediaPins } from '../../utils/data/LinksData';
// Constants
import { CompanyName } from '../../utils/constants/Constants';

function FollowMeOnCta() {
  return (
    <section className='grid w-full'>
      <div className='grid gap-6 px-6 sm:px-8 md:px-12'>
        {/* Media pins */}
        <section className='grid w-fit mx-auto'>
          <div className='grid grid-flow-col items-center gap-4 lg:gap-6'>
            {smallSocialMediaPins.map((pin) => (
              <a
                key={pin.serviceName}
                href={pin.url}
                className=''
                aria-label={`${CompanyName} social media link for ${pin.serviceName}`}
                target='_blank'
                rel='noreferrer'
              >
                <div className='grid items-center justify-center text-xl lg:text-3xl'>
                  {pin.icon}
                </div>
              </a>
            ))}
          </div>
        </section>

        <div className='text-center'>
            <p className='lg:text-xl opacity-75'>
              Follow Me on Twitter, <br /> contact Me, and spoil Me!
            </p>
          </div>
      </div>
    </section>
  );
}

export default FollowMeOnCta;
